<template>
  <el-dialog title="Edit TA" :visible.sync="dialogVisible" :scrollbar="false" width="400px" @open="onOpen"
    @closed="onClosed">
    <el-form class="padding-lr" ref="form" :model="form" :rules="formRules" @submit.native.prevent label-position="top">
      <el-form-item prop="taConfigId" label="TA">
        <el-select v-model="form.taConfigId" placeholder="Please select TA" style="width: 100%;" filterable @change="noMatch = false">
          <el-option v-for="item in taList" :key="item.taConfigId" :label="item.taConfigName" :value="item.taConfigId">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onSave" :loading='submitLoading'> Save </el-button>
      <el-button @click="dialogVisible = false"> Cancel </el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: "EditConfigDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  data() {
    return {
      taList: [],
      submitLoading: false,
      dialogVisible: this.visible,
      form: {
        taConfigId: "",
      },
      formRules: {
        taConfigId: [
          {
            required: true,
            trigger: 'change',
            validator: (rule, value, callback) => {
              const matched = this.taList.some((item) => item.taConfigId === value)
              if (!matched) {
                callback(new Error('Please select TA'))
              } else {
                callback()
              }
            },
          },
        ],
      },
      noMatch:false,
    };
  },
  watch: {
    visible(value) {
      this.dialogVisible = value;
    },
  },
  methods: {
    onSave() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if(this.noMatch){
            this.form.taConfigId = this.$store.state.userInfo.taConfigId
          }
          this.submitLoading = true
          this.axios
            .post(`/user/updateTa`, {
              taConfigId: this.form.taConfigId,
              userId: this.$store.state.userInfo.userID,
            })
            .then(({ code, msg }) => {
              this.submitLoading = false
              if (code === 200) {
                this.$message.success(`Edit TA successfully`);
                this.$store.commit("updateState", {
                  userInfo: {
                    ...this.$store.state.userInfo,
                    taConfigId: this.form.taConfigId,
                  },
                });
                this.onClosed()
              } else {
                this.$message.error(msg);
              }
            });
        } else {
          return false;
        }
      });
    },
    onOpen() {
      const taConfigId = this.$store.state.userInfo.taConfigId
      this.form.taConfigId = taConfigId
      this.axios
        .get(`/user/taConfig`)
        .then(({ code, msg, data }) => {
          if (code === 200) {
            this.taList = data
          } else {
            this.$message.error(msg);
          }
        });
        const duplicateIds = this.taList.filter(item => item.taConfigId === this.form.taConfigId);
        if (duplicateIds.length == 0) {
          this.noMatch = true
          this.form.taConfigId = this.$store.state.userInfo.taConfigName || '无匹配项'
        }
    },
    onClosed() {
      this.noMatch = false
      this.$refs.form.resetFields();
      this.$emit("update:visible", false);
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .el-dialog__body {
    padding: 0 10px 10px !important;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
  }
}

.el-form {
  width: 100%;
}

.dialog-footer {
  text-align: center;
}

.video-size {
  margin-left: 10px;
}

.el-icon-view {
  color: #909399;
  font-size: 14px;
  cursor: pointer;

  &:hover,
  &.active {
    color: $theme-color;
  }
}
</style>
